import axios from 'axios';
import { RoleData } from '../interfaces/IRoleManagement'
import Axios from '../utils/axiosInterceptor';
import { ROLE_MANAGEMENT } from '../utils/constants';


export const addRole = async (roleData: RoleData): Promise<RoleData> => {
  try {
    const response = await Axios.post<RoleData>(`${ROLE_MANAGEMENT.POST_ROLE_FUNCTIONALITIES}`, roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};